var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 26,
    viewBox: "0 0 42 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.91667 0.083374H8.08333V2.66671H10.6667V5.25004H13.25V7.83337H15.8333V10.4167H18.4167V13H23.5833V10.4167H26.1667V7.83337H28.75V5.25004H31.3333V2.66671H33.9167V0.083374H39.0833V2.66671H41.6667V7.83337H39.0833V10.4167H36.5V13H33.9167V15.5834H31.3333V18.1667H28.75V20.75H26.1667V23.3334H23.5833V25.9167H18.4167V23.3334H15.8333V20.75H13.25V18.1667H10.6667V15.5834H8.08333V13H5.5V10.4167H2.91667V7.83337H0.333332V2.66671H2.91667V0.083374Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrowDown.9657bd53988e49a2b86d1e91fe600f60.svg";
export { ForwardRef as ReactComponent };